import { Box, Checkbox, ListItemButton, ListItemText } from '@mui/material'
import _ from 'lodash'

import type { CreateListItemProps, Option } from '../types'
import type { FieldValues } from 'react-hook-form'

type Props<T extends FieldValues> = Pick<CreateListItemProps<T>, 'disabled' | 'field'> & {
  currentValue: Option
  path: string
}

export const CheckboxNode = <T extends FieldValues>({
  currentValue,
  disabled,
  field,
  path,
}: Props<T>) => {
  const { onChange, value: formValue } = field

  const isCheckedPath: string = `${path}.isChecked`
  const isChecked: boolean = _.get(formValue, isCheckedPath) || false

  return (
    <Box>
      <ListItemButton
        disabled={disabled}
        id={path}
        onClick={() => void onChange(_.set(formValue, isCheckedPath, !isChecked))}
        sx={{ pl: 5, py: 0 }}
      >
        <Checkbox
          checked={isChecked}
          edge='start'
        />
        <ListItemText
          id={path}
          primary={currentValue.label}
        />
      </ListItemButton>
    </Box>
  )
}
